export default "__VITE_ASSET__CleiZPnv__"